import type { BaseController } from '@infra/controllers/base.controller';
import type { SendDigitsUsecase } from '@usecases/send-digits.usecase';

export type SendDigitsInput = {
  digits: string;
};

export class SendDigitsController
  implements BaseController<SendDigitsInput, void>
{
  constructor(private usecase: SendDigitsUsecase) {}

  async handle(req: SendDigitsInput): Promise<void> {
    await this.usecase.run(req.digits);
  }
}
